export const get3DSObject = (price, nameOnCard) => ({
  amount: Math.round(100.0 * price),
  cardHolder: nameOnCard
})